import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { LuBrain } from "react-icons/lu";
import { RiProgress1Line } from "react-icons/ri";
import { RiProgress5Line } from "react-icons/ri";
import { RiProgress8Line } from "react-icons/ri";
import useFlashcardStats from "../../hooks/useFlashcardStats";
import "./FlashcardProgress.css";

export default function FlashcardProgress({ compact = false }) {
  const { user } = useAuth();
  const { stats, loading } = useFlashcardStats();

  if (loading) return <p>Carregando...</p>;

  return (
    <div className={`flashcard-progress ${compact ? "compact" : ""}`} >
      <div className="flashcard-progress-card">
        <div className="flashcard-progress-header">
          {/* Left side — main total */}
          <div className="flashcard-left">
            <LuBrain size={25} className="flashcard-progress-icon" />
            <span className="flashcard-progress-number">
              {stats.total}
              <span className="flashcard-progress-label">Flashcards</span>
            </span>
          </div>

          {/* Right side — side-by-side icons */}
          <div className="flashcard-right">
            <div className="flashcard-right-item new">
              <span className="count">{stats.new}</span>
              <RiProgress1Line size={20} />
            </div>
            <div className="flashcard-right-item learning">
              <span className="count">{stats.learning}</span>
              <RiProgress5Line size={20} />
            </div>
            <div className="flashcard-right-item known">
              <span className="count">{stats.known}</span>
              <RiProgress8Line size={20} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

